import { Task } from "fond/types/task";

import { apiSlice } from "./apiSlice";

export const taskSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getTask: build.query<Task, { ID: string }>({
      query: ({ ID }) => ({
        url: `/v2/tasks/${ID}`,
      }),
      providesTags: (result) => (result ? [{ type: "Task", id: result.ID }] : []),
    }),
  }),
});

/**
 * Endpoint hooks
 */
export const { useGetTaskQuery } = taskSlice;
